import React, { Component, Fragment, createRef } from 'react';
import { Label } from 'atoms/Texts';
import CollabInput from 'molecules/CollaborationInput';
import { MessageContainer } from 'molecules/CollaborationItem';
import { ContentWrapper, ScrollList } from './styles';
import lo from 'lodash';

class CollaborationContent extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.scrollRef = createRef()
  }

  componentDidUpdate(prevProps, prevState) {
    const { data: prevData } = prevProps
    const { data: newData } = this.props
    if (prevData !== newData) {
      this.calculateHeight()
    }
  }

  componentDidMount() {
    this.calculateHeight()
  }

  calculateHeight() {
    let currentRef = this.scrollRef.current
    let listHeight = currentRef.clientHeight
    currentRef.scrollTo(0, listHeight)
  }

  render() {
    const { isLoadingInput, depts, data, taskData, ...rest } = this.props

    return (
      <ContentWrapper>
        <ScrollList ref={this.scrollRef}>
          {data.length > 0 ?
            <Fragment>
              {data.map((item, i) => (
                <MessageContainer
                  key={i}
                  first={i !== 0}
                  last={i !== (data.length - 1)}
                  {...item}
                />
              ))}
            </Fragment> :
            <Label>No collaborations.</Label>
          }
        </ScrollList>
        {(!lo.isEmpty(taskData) && !taskData.isClosed) &&
          <CollabInput
            isLoadingInput={isLoadingInput}
            depts={depts}
            taskData={taskData}
            {...rest}
          />
        }
      </ContentWrapper>
    );
  }
}

export default CollaborationContent;
